import React from 'react';
import classNames from 'classnames';
import styles from './StatusBar.module.scss';
import { getActiveSegment } from './helpers/get-active-segment';
export var ActiveColors;
(function (ActiveColors) {
    ActiveColors["green"] = "green";
    ActiveColors["yellow"] = "yellow";
    ActiveColors["red"] = "red";
})(ActiveColors || (ActiveColors = {}));
export var InactiveColor;
(function (InactiveColor) {
    InactiveColor["grey"] = "grey";
})(InactiveColor || (InactiveColor = {}));
export var Size;
(function (Size) {
    Size["small"] = "small";
    Size["medium"] = "medium";
})(Size || (Size = {}));
export const StatusBar = ({ segments = 10, value, label, activeColor = ActiveColors.green, disabledColor = InactiveColor.grey, size = Size.small, }) => {
    const activeSegment = getActiveSegment(value, segments);
    const getSegmentColor = (segmentNumber) => {
        return segmentNumber <= activeSegment ? activeColor : disabledColor;
    };
    return (<div>
      <span className={styles.label}>{label}</span>
      <div className={styles.indicatorContainer}>
        {Array.from(Array(segments)).map((x, index) => (<div className={classNames(styles.bar, {
                [styles.small]: size === Size.small,
                [styles.medium]: size === Size.medium,
                [styles.green]: getSegmentColor(index + 1) === ActiveColors.green,
                [styles.yellow]: getSegmentColor(index + 1) === ActiveColors.yellow,
                [styles.red]: getSegmentColor(index + 1) === ActiveColors.red,
                [styles.grey]: getSegmentColor(index + 1) === InactiveColor.grey,
                [styles.lastActiveBar]: index === activeSegment - 1,
                [styles.lastActiveBarMedium]: size === Size.medium && index === activeSegment - 1,
            })} key={index}/>))}
      </div>
    </div>);
};
